export const API_URI = '/api/covid/';


// WEBPACK FOOTER //
// ./frontEnd/covid/permiso-unico-colectivo/consts/index.js